import type { FaireProductEntity } from "../../entity_types/product";

export const p_c83uy6h6br: FaireProductEntity = {
  token: "p_c83uy6h6br",
  type: "product",
  name: "Stilts",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/88f2167d5189af72a4fbd1fb01eb01bf5a76a9a7accb0ccc891494a416bc002a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32fb8219166437186c19e9e39b2c255bb5fc9dcc483d40ec411d6bb73f6ed905.jpeg",
    "https://cdn.faire.com/fastly/a357484560866f9c464264ac5dfda4ef329596c5ee49821c507054e1940f3621.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:56.440Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
